import { signChallenge } from "@/lib/identity";

const WS_URL = `${process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws")}/api/relay`;

export function connectRelay(me, { onItems, onStatus }) {
  let ws;
  let closed = false;
  let timer;
  let ready = false;

  const open = () => {
    onStatus("connecting");
    ws = new WebSocket(WS_URL);
    ws.onmessage = (e) => {
      const m = JSON.parse(e.data);
      if (m.type === "challenge") ws.send(JSON.stringify({ type: "auth", sign_pk: me.sign_pk, sig: signChallenge(m.nonce, me.sign_sk) }));
      else if (m.type === "ready") { ready = true; onStatus("connected"); }
      else if (m.type === "deliver") onItems(m.items);
    };
    ws.onclose = () => {
      ready = false;
      onStatus("disconnected");
      if (!closed) timer = setTimeout(open, 2500);
    };
  };

  open();
  const ping = setInterval(() => ready && ws.send('{"type":"ping"}'), 25000);

  return {
    send: (items) => {
      if (!ready || ws.readyState !== 1) return false;
      for (let i = 0; i < items.length; i += 60) ws.send(JSON.stringify({ type: "send", items: items.slice(i, i + 60) }));
      return true;
    },
    raw: (obj) => ready && ws.send(JSON.stringify(obj)),
    ack: (ids) => ready && ids.length && ws.send(JSON.stringify({ type: "ack", ids })),
    close: () => {
      closed = true;
      clearTimeout(timer);
      clearInterval(ping);
      ws?.close();
    },
  };
}
